var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.history.length > 0)?_c('carousel',{attrs:{"gap":{
  base: 16,
  sm: 16,
  md: 32,
  lg: 16,
  xl: 32
},"title":_vm.__(`messages.continue_with_search${_vm.site.siteName}`)}},_vm._l((_vm.history),function(registry){return _c('recent-search',{key:registry.id,attrs:{"hrefe":registry.url,"image":registry.image,"type":registry.title,"icon-class":registry.icon,"destination":registry.name,"dates":_vm.formatDate(registry.startDate, registry.endDate, registry.mode),"guests":registry.paxInfo}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }